import { infer as Infer, input as Input, z } from 'zod';

export const assignmentSubmissionSchema = z.object({
  body: z.string().trim().max(2000, 'Odpowiedź nie może przekraczać 2000 znaków').nullable().optional(),
});

export const assignmentSubmissionEditSchema = assignmentSubmissionSchema.extend({
  removeFileIdArr: z.array(z.string().uuid()).optional(),
});

export const assignmentFeedbackSchema = z.object({
  overall: z
    .string()
    .trim()
    .max(2000, 'Komentarz nie może przekraczać 2000 znaków')
    .nullable()
    .transform((value) => value || null),
  files: z
    .record(z.string().uuid(), z.string().trim().max(2000, 'Komentarz nie może przekraczać 2000 znaków'))
    .transform((files) => Object.fromEntries(Object.entries(files).filter(([, comment]) => comment.length > 0))),
});

export type AssignmentSubmissionSchema = Infer<typeof assignmentSubmissionSchema>;
export type AssignmentSubmissionEditSchema = Infer<typeof assignmentSubmissionEditSchema>;
export type AssignmentFeedbackSchema = Infer<typeof assignmentFeedbackSchema>;
export type AssignmentFeedbackSchemaInput = Input<typeof assignmentFeedbackSchema>;
